<!--
    These three inputs hold a Social Security Number, so they are deliberately excluded from
    every form-recall mechanism a browser or extension might offer:

    - autocomplete="off" stops the browser saving the value for later autocompletion AND stops
      it caching the value in the session history (so back/forward navigation cannot restore
      it after a session ends).  The documented cases where browsers override "off" are login
      username/password fields and Autofill's address/payment profile categories; none apply
      here, so it is honoured on all supported browsers (Edge, Chrome, Firefox).
    - The data-* attributes opt out of third-party password managers (1Password, Bitwarden,
      LastPass, Dashlane), which are extensions and do not act on autocomplete="off".
    - There is intentionally NO name or id attribute.  Form-history lookup keys on field
      identity, and adding name="ssn"/id="ssn" would hand the browser's field classifier
      exactly the hint it currently lacks.  Do not add them.

    Deliberately NOT using autocomplete="new-password": it would invite "suggest a strong
    password" UI and save prompts on an SSN field.  Note this diverges from the non-standard
    per-application tokens the AutocompletePipe emits for other fields; "off" is correct here.
-->
<div
    role="group"
    class="example-ssn-input-container"
    [formGroup]="parts"
    [attr.aria-labelledby]="_formField.getLabelId()"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
>
    <input
        class="example-ssn-input-element"
        formControlName="area"
        size="3"
        maxLength="3"
        aria-label="Area number"
        (input)="_handleInput(parts.controls.area, group)"
        inputmode="numeric"
        autocomplete="off"
        data-1p-ignore
        data-bwignore
        data-lpignore="true"
        data-form-type="other"
        #area
    />
    <span class="example-ssn-input-spacer">&ndash;</span>
    <input
        class="example-ssn-input-element"
        formControlName="group"
        maxLength="2"
        size="2"
        aria-label="Group number"
        (input)="_handleInput(parts.controls.group, serial)"
        (keyup.backspace)="autoFocusPrev(parts.controls.group, area)"
        inputmode="numeric"
        autocomplete="off"
        data-1p-ignore
        data-bwignore
        data-lpignore="true"
        data-form-type="other"
        #group
    />
    <span class="example-ssn-input-spacer">&ndash;</span>
    <input
        class="example-ssn-input-element"
        formControlName="serial"
        maxLength="4"
        size="4"
        aria-label="Serial number"
        (input)="_handleInput(parts.controls.serial)"
        (keyup.backspace)="autoFocusPrev(parts.controls.serial, group)"
        inputmode="numeric"
        autocomplete="off"
        data-1p-ignore
        data-bwignore
        data-lpignore="true"
        data-form-type="other"
        #serial
    />
</div>
